import { createTheme } from '@one-thd/sui-atomic-components';

const SummerPrimaryYellowTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

SummerPrimaryYellowTwo.palette['--sui-palette-background-primary'] = '249 236 124';

export { SummerPrimaryYellowTwo };
